<template>
    <div class="grid grid-cols-3 border-b border-a-brown-d7c7b8 text-14 text-a-brown-502314 font-bold pt-1">
        <router-link to="/history/point" replace
             class="py-2 text-center border-b-4"
             :class="[getTabClass('point')]">{{lbl.history.earn}}</router-link>
        <router-link to="/history/redeem" replace
             class="py-2 text-center border-b-4"
             :class="[getTabClass('redeem')]">{{lbl.history.redeem}}</router-link>
        <router-link to="/history/expire" replace
             class="py-2 text-center border-b-4"
             :class="[getTabClass('expire')]">{{lbl.history.expire}}</router-link>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'HistoryTab',
    mixins: [LocaleMixin],
    data: function() {
        return {
            active: '', // point, redeem, expire
        }
    },
    created: function() {
        this.active = this.$route.params.tab;
        if (Util.isEmptyStr(this.active)) {
            this.active = 'point';
        }
    },
    methods: {
        getTabClass: function(tab) {
             this.callTracking(tab)
            if (tab == this.active) {
                return 'text-a-red-d62300 border-a-red-d62300';
            } else {
                return 'border-transparent';
            }
        },
        callTracking: function(tab){
            if(tab == 'point'){
                tab = 'earn'
            }

            this.tracking.event('point History',`click_${tab}_point_history`, null, 'Ex. \n 1. click_earn_point_history\n 2. click_redeem_point_history\n 3. click_expire_point_history');

        }
    },
}
</script>
<style lang="scss" scoped>
    .tab-width {
        max-width: 320px;
    }
</style>
